if (!customElements.get('sesseq-combination')) {
  customElements.define('sesseq-combination', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.button = this.querySelector('[data-add]');
      this.summary = this.querySelector('[data-summary]');
      this.status = this.querySelector('[data-status]');
      this.format = new Intl.NumberFormat(document.documentElement.lang || 'nl-BE', {style:'currency',currency:this.dataset.currency || 'EUR'});
      this.addEventListener('change', event => {
        const card = event.target.closest('.sc-card');
        if (card && event.target.matches('[data-select]') && event.target.checked && !this.variant(card).id) {
          event.target.checked = false;
          card.querySelector('select')?.focus();
          this.status.textContent = this.dataset.variantMessage;
        } else this.status.textContent = '';
        this.update();
      });
      this.querySelectorAll('.sc-hotspot').forEach(link => link.addEventListener('click', () => {
        this.querySelector(link.getAttribute('href'))?.focus({preventScroll:true});
      }));
      this.button.addEventListener('click', () => this.add());
      this.update();
    }
    variant(card) {
      const control = card.querySelector('[data-variant]');
      const option = control?.tagName === 'SELECT' ? control.selectedOptions[0] : control;
      return {id:control?.value,price:Number(option?.dataset.price || 0),disabled:Boolean(option?.disabled)};
    }
    selected() {
      return [...this.querySelectorAll('.sc-card')].filter(card => {
        const variant = this.variant(card);
        return card.dataset.purchasable === 'true' && card.querySelector('[data-select]:checked') && variant.id && variant.price > 0 && !variant.disabled;
      });
    }
    update() {
      this.querySelectorAll('.sc-card').forEach(card => {
        const variant = this.variant(card);
        const price = card.querySelector('[data-price]');
        if (!price.dataset.initialPrice) price.dataset.initialPrice = price.textContent;
        price.textContent = variant.id && variant.price > 0 ? this.format.format(variant.price / 100) : price.dataset.initialPrice;
      });
      const cards = this.selected();
      const total = cards.reduce((sum, card) => sum + this.variant(card).price, 0);
      this.summary.textContent = cards.length ? this.dataset.selected.replace('[count]',cards.length) + ' · ' + this.format.format(total / 100) : this.dataset.empty;
      this.button.disabled = !cards.length || Boolean(this.busy);
    }
    async add() {
      const items = this.selected().map(card => ({id:this.variant(card).id,quantity:1}));
      if (!items.length || this.busy) return;
      this.busy = true;
      this.update();
      this.status.textContent = this.dataset.adding;
      this.setAttribute('aria-busy','true');
      try {
        const response = await fetch(this.dataset.addUrl,{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items})});
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || this.dataset.error);
        this.status.textContent = this.dataset.added;
        window.location.assign(this.dataset.cartUrl);
      } catch(error) {
        this.status.textContent = error.message || this.dataset.error;
        this.busy = false;
        this.removeAttribute('aria-busy');
        this.update();
      }
    }
  });
}

